/**
 * 登录（密码登录 + 回跳）
 * ★ 2026-08-24 清理：下线短信验证码登录 tab 与图形验证码 UI —
 *   后端无 /auth/sms-login、/auth/captcha、/auth/send-sms 路由，入口保留只会报错（T4 后门清理闭环）。
 *   仅保留密码登录，后端实现短信/验证码后再恢复 UI。
 */
import { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { login } from '@/api/auth';
import { useAuth } from '@/stores/auth';
import PageHero from '@/components/common/PageHero';
import '@/styles/pages/auth.css';

export default function Login() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const redirect = searchParams.get('redirect') ?? '/';
  const registered = searchParams.get('registered') === '1';
  const { login: authLogin } = useAuth();

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async () => {
    setError('');
    if (!username.trim() || !password.trim()) {
      setError('请输入用户名/手机号和密码');
      return;
    }
    setSubmitting(true);
    try {
      const result = await login({ username, password });
      authLogin(result);
      navigate(redirect, { replace: true });
    } catch (e) {
      setError(e instanceof Error ? e.message : '登录失败');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="auth-page">
      <PageHero eyebrow="WELCOME BACK" title="登录云牛集" desc="买卖牛只 · 参与竞价 · 经纪撮合" />
      <div className="container">
        <div className="auth-card">
          <div className="auth-form">
            <div className="form-group">
              <label className="form-label">用户名 / 手机号</label>
              <input className="form-control" placeholder="请输入用户名或手机号" value={username} onChange={(e) => setUsername(e.target.value)} />
            </div>
            <div className="form-group">
              <label className="form-label">密码</label>
              <input className="form-control" type="password" placeholder="请输入密码" value={password} onChange={(e) => setPassword(e.target.value)} onKeyDown={(e) => e.key === 'Enter' && handleSubmit()} />
            </div>
          </div>

          {registered ? <div className="auth-ok">注册成功，请登录</div> : null}
          {error ? <div className="form-error">{error}</div> : null}

          <button className="btn btn-primary btn-block btn-lg" disabled={submitting} onClick={handleSubmit}>
            {submitting ? '登录中…' : '登录'}
          </button>

          <div className="auth-links">
            <span className="auth-forgot">忘记密码？</span>
            <Link to="/register" className="auth-register">没有账号？立即注册</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
